<template>
  <div>
    <div
      class="flex flex-col gap-4 mt-10 md:flex-row"
    >
      <h1
        class="text-xl text-left text-sc-gray-dark"
        ref="google-sheets-title"
      >
        {{ $t('message.settings.sheetsTab.googleSheet') }}
      </h1>
      <div
        class="md:ml-10"
      >
        <button
          ref="previous-button"
          class="px-2 py-1 text-sm bg-white rounded shadow-sc-button text-primary disabled:text-disabled disabled:cursor-default"
          :disabled="activeStep <= 1"
          @click="previousStep()"
        >
          {{ $t('message.settings.sheetsTab.previousButton') }}
        </button>
        <button
          ref="next-button"
          class="px-2 py-1 ml-1 text-sm bg-white rounded shadow-sc-button text-primary disabled:text-disabled disabled:cursor-default"
          :disabled="activeStep >= totalSteps"
          @click="nextStep()"
        >
          {{ $t('message.settings.sheetsTab.nextButton') }}
        </button>
      </div>
    </div>
    <div class="h-auto mt-8">
      <div
        v-for="(step, index) in steps"
        :key="index"
      >
        <sheet-stepper-item
          :ref="`stepper-item-${index + 1}`"
          :title="step.title"
          :content="step"
          :step="index + 1"
          :is-active="activeStep === index + 1"
          :is-last="index === totalSteps - 1"
          @copy-message="copyToClipboard"
          @connect="connect"
        />
      </div>
    </div>
  </div>
</template>
<script>
import SheetStepperItem from './sheet-stepper-item.vue';

const GOOGLE_SERVICE_ACCOUNT = import.meta.env.VITE_GOOGLE_SERVICE_ACCOUNT;

export default {
  data() {
    return {
      newSheetUrl: '',
      activeStep: 1,
      steps: [
        {
          title: this.$t('message.settings.sheetsTab.steps.createGoogleSheet'),
          lines: [
            {
              message: this.$t('message.settings.sheetsTab.steps.contents.createGoogleSheet'),
            },
            {
              message: 'www.google.com/sheets',
              href: 'https://www.google.com/sheets',
            },
          ],
        },
        {
          title: this.$t('message.settings.sheetsTab.steps.givePermissions'),
          lines: [
            {
              message: this.$t('message.settings.sheetsTab.steps.contents.givePermissions'),
            },
            {
              message: GOOGLE_SERVICE_ACCOUNT,
              href: `mailto:${GOOGLE_SERVICE_ACCOUNT}`,
              action: {
                button: this.$t('message.settings.sheetsTab.steps.copyButton'),
                emit: 'copy-message',
                value: GOOGLE_SERVICE_ACCOUNT,
              },
            },
          ],
        },
        {
          title: this.$t('message.settings.sheetsTab.steps.getLink'),
          lines: [
            {
              message: this.$t('message.settings.sheetsTab.steps.contents.getLink'),
            },
          ],
        },
        {
          title: this.$t('message.settings.sheetsTab.steps.connectToSupercartola'),
          input: {
            placeholder: this.$t('message.settings.sheetsTab.steps.contents.connectToSupercartola'),
            button: this.$t('message.settings.sheetsTab.steps.finishButton'),
            emit: 'connect',
          },
        },
      ],
    };
  },
  components: {
    SheetStepperItem,
  },
  methods: {
    nextStep() {
      this.activeStep += 1;
    },
    previousStep() {
      this.activeStep -= 1;
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text)
        .then(this.$buefy.toast.open({
          message: this.$t('message.settings.sheetsTab.copyLinkSuccess'),
          position: 'is-bottom',
        }));
    },
    connect(url) {
      this.$emit('connect', url);
    },
  },
  computed: {
    totalSteps() {
      return Object.keys(this.steps).length;
    },
  },
};
</script>
